import React, { useEffect } from 'react';
import FourDotLoader from 'components/FourDotLoader';
import useQueryParams from 'hooks/useQueryParams';
import api from 'api';
import { sentryError } from 'utils';
import { useNavigate } from 'react-router';
import { BUSINESS_ROUTE } from 'data/global';

const DocusignUrl: React.FC = () => {
  const {
    params: { envelopeId, signerEmail, signerName, listingEnquiryId },
  } = useQueryParams();

  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      try {
        const {
          data: { url },
        } = await api.general.getDocusignUrl(
          envelopeId,
          signerEmail.replaceAll(' ', '+').trim(),
          signerName,
          listingEnquiryId,
        );
        window.location.href = url;
      } catch (error) {
        sentryError(error);
        navigate(BUSINESS_ROUTE, { replace: true });
      }
    })();
  }, [envelopeId, signerEmail, signerName, navigate, listingEnquiryId]);

  return (
    <div>
      <FourDotLoader />
    </div>
  );
};

export default DocusignUrl;
